import { render, staticRenderFns } from "./ProductBox.html?vue&type=template&id=10fee92e&scoped=true&"
import script from "./ProductBox.js?vue&type=script&lang=js&"
export * from "./ProductBox.js?vue&type=script&lang=js&"
import style0 from "./ProductBox.scss?vue&type=style&index=0&id=10fee92e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fee92e",
  null
  
)

export default component.exports